import { Stack } from '@mui/material'
import React from 'react'

import { PollingIntervalField } from 'components/status-checks/common/PollingIntervalField'
import { StatusCheckCategoryField } from 'components/status-checks/common/StatusCheckCategoryField'
import { StatusCheckUrlAndSuccessEvaluation } from 'components/status-checks/form/status-check/StatusCheckUrlAndSuccessEvaluation'
import { useFeatureFlags } from 'hooks/use-feature-flags'

export const StatusCheckConnectionForm: React.FC = () => {
  const {
    reliabilityIntelligenceRunSuggestions:
      hasEnabledReliabilityIntelligenceRunSuggestions
  } = useFeatureFlags()

  return (
    <Stack sx={{ rowGap: 4 }}>
      <StatusCheckUrlAndSuccessEvaluation />
      <PollingIntervalField />
      {hasEnabledReliabilityIntelligenceRunSuggestions && (
        <StatusCheckCategoryField />
      )}
    </Stack>
  )
}
